module.exports = __webpack_public_path__ + "img/10.5f12ba0a.jpg";